export const pattern23Data = [
  {
    koreanChunks: ["보관하세요 모든 물품을", "허리 높이 위에", "보관하는 동안"],
    englishChunks: [
      "Please keep all items",
      "above waist level",
      "during storage",
    ],
    fullEnglish: "Please keep all items above waist level during storage.",
    additionalExplanation:
      "원어민은 전치사를 진짜 많이 사용합니다. 영어에서 접착제 역할을 하는 것이 전치사입니다. 실제 영어 어순대로 읽을 때 끊어 읽는 단위가 전치사이기도 한데요, ~위에, ~동안으로 계속 뒤에 접착되는 것을 볼 수 있습니다. 허리 높이 위에, 보관하는 동안 이런 말을 하려면 어떤 전치사를 써야 할까? 고민하면서 훈련해보세요",
  },
  {
    koreanChunks: [
      "저는 글을 쓰고 있습니다",
      "팔로우업하기 위해",
      "회의에 관해",
      "예정된 금요일에",
    ],
    englishChunks: [
      "I'm writing",
      "to follow up",
      "about the meeting",
      "scheduled for Friday",
    ],
    fullEnglish:
      "I'm writing to follow up about the meeting scheduled for Friday.",
    additionalExplanation:
      "~에 관해, 금요일에 이런 말을 할 때 어떤 전치사를 써야 할지는 계속 문장을 많이 보면서 익숙해지는 게 제일 좋습니다.  ",
  },
  {
    koreanChunks: ["연락하세요", "인사 담당자에게", "남은 휴가일에 관해"],
    englishChunks: [
      "Please contact",
      "the HR manager",
      "about your remaining vacation days",
    ],
    fullEnglish:
      "Please contact the HR manager about your remaining vacation days.",
    additionalExplanation:
      "이 문장에서는  '~에 관해(about)'라는 전치사가 사용되었습니다. 전치사는 말할 때는 먼저 전치사를 말하고(about) 뒤의 내용(remaining days)을 이어가지만 해석할 때는 전치사 부분은 건너뛰고, 뒷부분을 말한 다음(남은 휴가일)에 해당 전치사(~에 관해)로 붙여서 읽습니다.",
  },
  {
    koreanChunks: [
      "우리의 새 매장 위치들은 퍼져있습니다",
      "다섯 개의 주요 도시에 걸쳐",
    ],
    englishChunks: [
      "Our new store locations are spread",
      "across five major cities",
    ],
    fullEnglish: "Our new store locations are spread across five major cities.",
    additionalExplanation:
      "이 문장에서는 '~에 걸쳐(across)'라는 전치사가 사용되었습니다. 전치사 'across'는 '가로질러', '~에 걸쳐'라는 의미로 공간적 분포를 나타낼 때 자주 사용됩니다.",
  },
  {
    koreanChunks: ["새 정책은 효력이 발생합니다", "이사회가 승인한 후에"],
    englishChunks: [
      "The new policy takes effect",
      "after the board approves it",
    ],
    fullEnglish: "The new policy takes effect after the board approves it.",
    additionalExplanation:
      "이 문장에서는 '~후에(after)'라는 전치사가 사용되었습니다. 해석할 때는 전치사를 뒤에 (~후에) 붙여 해석하고 전치사구는 끊지 않고 한꺼번에 읽습니다. 다만 말하는 화자의 입장의 경우 전치사를 먼저 말을 한 다음에 그 다음에 말을 붙여 나갑니다.",
  },
  {
    koreanChunks: ["기대는것 물건을", "비상구에", "엄격하게 금지되있다"],
    englishChunks: [
      "Leaning items",
      "against the emergency exits",
      "is strictly prohibited",
    ],
    fullEnglish:
      "Leaning items against the emergency exits is strictly prohibited.",
    additionalExplanation:
      "이 문장에서는 '~에(against)'라는 전치사가 사용되었습니다. 전치사 'against'는 '~에 기대어', '~에 반하여'라는 의미로 물체가 다른 물체에 접촉하거나 기대어 있는 상태를 표현할 때 사용됩니다. ",
  },
  {
    koreanChunks: ["홍보 자료가 배포될 것입니다", "주요 복도를 따라"],
    englishChunks: [
      "Promotional materials will be distributed",
      "along the main hallway",
    ],
    fullEnglish:
      "Promotional materials will be distributed along the main hallway.",
    additionalExplanation:
      "이 문장에서는 '~을 따라(along)'라는 전치사가 사용되었습니다. 해석할 때는 전치사를 뒤에 (~을 따라) 붙여 해석하고 전치사구는 끊지 않고 한꺼번에 읽습니다. 다만 말하는 화자의 입장의 경우 전치사를 먼저 말을 한 다음에 그 다음에 말을 붙여 나갑니다.",
  },
  {
    koreanChunks: ["새 인턴은 일할 것입니다", "마케팅 팀과 함께"],
    englishChunks: ["The new intern will work", "alongside the marketing team"],
    fullEnglish: "The new intern will work alongside the marketing team.",
    additionalExplanation:
      "이 문장에서는 '~와 함께(alongside)'라는 전치사가 사용되었습니다. 전치사 'alongside'는 '~의 옆에', '~와 함께'라는 의미로 누군가와 협력하거나 나란히 일하는 상황을 표현할 때 사용됩니다. 해석할 때는 전치사 부분을 뒤에 붙여서 해석하지만, 영어로 말할 때는 전치사를 먼저 말하고 그 뒤에 명사구를 이어갑니다.",
  },
  {
    koreanChunks: ["예산 삭감 속에서", "회사는 확장했습니다", "해외 사업을"],
    englishChunks: [
      "Amid budget cuts",
      "the company expanded",
      "its overseas operations",
    ],
    fullEnglish:
      "Amid budget cuts, the company expanded its overseas operations.",
    additionalExplanation:
      "이 문장에서는 '~속에서(amid)'라는 전치사가 사용되었습니다. 전치사 'amid'는 '~가운데', '~속에서'라는 의미로 어떤 상황이나 환경 속에서 일어나는 일을 표현할 때 사용됩니다. 이 문맥에서는 예산 삭감이라는 상황 속에서 회사가 해외 사업을 확장했다는 의미를 나타냅니다.",
  },
  {
    koreanChunks: [
      "지원자들 중에서",
      "세 명이 선발되었습니다",
      "최종 라운드를 위해",
    ],
    englishChunks: [
      "Among the applicants",
      "three were selected",
      "for the final round",
    ],
    fullEnglish:
      "Among the applicants, three were selected for the final round.",
    additionalExplanation:
      "이 문장에서는 '~중에서(among)'라는 전치사가 사용되었습니다. 전치사 'among'은 '~중에서', '~사이에서'라는 의미로 '세 개 이상'의 대상 중에서 선택하거나 그 관계를 표현할 때 사용됩니다.",
  },

  {
    koreanChunks: ["만납시다", "오후 3시쯤에", "검토하기 위해 프레젠테이션을"],
    englishChunks: [
      "Let's meet",
      "around 3 p.m.",
      "to review the presentation",
    ],
    fullEnglish: "Let's meet around 3 p.m. to review the presentation.",
    additionalExplanation:
      "이 문장에서는 '~쯤에(around)'라는 전치사가 사용되었습니다. 전치사 'around'는 시간이나 장소와 함께 사용될 때 '~쯤에', '~부근에'라는 의미를 가집니다. 이 전치사의 경우 해석과 읽는것을 모두 동일하게 앞에서 합니다.",
  },
  {
    koreanChunks: ["그녀는 합류했습니다", "팀에", "재무 분석가로서"],
    englishChunks: ["She joined", "the team", "as a financial analyst"],
    fullEnglish: "She joined the team as a financial analyst.",
    additionalExplanation:
      "이 문장에서는 '~로서(as)'라는 전치사가 사용되었습니다. 전치사 'as'는 '~로서', '~의 자격으로'라는 의미로 어떤 역할이나 기능을 나타낼 때 사용됩니다. 해석할 때는 전치사 부분을 뒤에 붙여서 해석하지만, 영어로 말할 때는 전치사를 먼저 말하고 그 뒤에 명사구를 이어갑니다.'as'는 직책, 직업, 역할을 표현할 때 자주 사용되는 전치사입니다.",
  },
  {
    koreanChunks: ["회의가 시작될 것입니다", "정확히 오전 10시에"],
    englishChunks: ["The meeting will begin", "at 10 a.m. sharp"],
    fullEnglish: "The meeting will begin at 10 a.m. sharp.",
    additionalExplanation:
      "이 문장에서는 '~에(at)'라는 전치사가 사용되었습니다. 전치사 'at'은 특정 시간을 나타낼 때 사용됩니다. 여기서는 정확히 오전 10시라는 특정 시간을 지정하고 있습니다. 'sharp'이라는 부사는 '정확히', '딱'이라는 의미로 시간이 정확함을 강조합니다. 이 표현은 시간 엄수가 중요한 공식적인 상황에서 자주 사용됩니다.",
  },
  {
    koreanChunks: [
      "어떤 예상치 못한 지연이 없다면",
      "배송이 도착할 것입니다",
      "내일",
    ],
    englishChunks: [
      "Barring any unexpected delays",
      "the shipment will arrive",
      "tomorrow",
    ],
    fullEnglish:
      "Barring any unexpected delays, the shipment will arrive tomorrow.",
    additionalExplanation:
      "이 문장에서는 '~이 없다면(barring)'이라는 전치사가 사용되었습니다. 전치사 'barring'은 '~이 없다면', '~을 제외하고'라는 의미로 어떤 조건이나 상황이 발생하지 않는다는 가정을 표현할 때 사용됩니다. 'barring'은 공식적인 비즈니스 커뮤니케이션에서 조건부 상황을 표현할 때 자주 사용되는 표현입니다.",
  },
  {
    koreanChunks: ["모든 경비는 승인되어야 합니다", "환급 전에"],
    englishChunks: ["All expenses must be approved", "before reimbursement"],
    fullEnglish: "All expenses must be approved before reimbursement.",
    additionalExplanation:
      "이 문장에서는 '~전에(before)'라는 전치사가 사용되었습니다. 전치사 'before'는 시간적 순서에서 '~전에'라는 의미를 가집니다.해석할 때는 전치사 부분을 뒤에 붙여서 해석하지만, 영어로 말할 때는 전치사를 먼저 말하고 그 뒤에 명사구를 이어갑니다.",
  },
  {
    koreanChunks: ["보관 구역은 위치해 있습니다", "적재 도크 뒤에"],
    englishChunks: ["The storage area is located", "behind the loading dock"],
    fullEnglish: "The storage area is located behind the loading dock.",
    additionalExplanation:
      "이 문장에서는 '~뒤에(behind)'라는 전치사가 사용되었습니다. 전치사 'behind'는 공간적 위치 관계에서 '~의 뒤에', '~의 후방에'라는 의미를 가집니다. ",
  },

  {
    koreanChunks: ["서버는 설치되어 있습니다", "워크스테이션 아래에"],
    englishChunks: ["The server is installed", "beneath the workstation"],
    fullEnglish: "The server is installed beneath the workstation.",
    additionalExplanation:
      "이 문장에서는 '~아래에(beneath)'라는 전치사가 사용되었습니다. 전치사 'beneath'는 '~의 아래에', '~의 밑에'라는 의미로 공간적 위치 관계를 나타낼 때 사용됩니다. 'beneath'는 'under'와 유사하지만 좀 더 공식적이거나 문학적인 표현으로, 정확한 위치 관계를 설명할 때 사용됩니다.",
  },
  {
    koreanChunks: ["당신의 좌석은", "창가 옆에 있습니다", "회의실안의"],
    englishChunks: [
      "Your seat is",
      "beside the window",
      "in the conference room",
    ],
    fullEnglish: "Your seat is beside the window in the conference room.",
    additionalExplanation:
      "이 문장에서는 '~옆에(beside)'라는 전치사가 사용되었습니다. 전치사 'beside'는 '~의 옆에', '~의 곁에'라는 의미로 공간적 위치 관계를 나타낼 때 사용됩니다",
  },
  {
    koreanChunks: [
      "더 낮은 비용 외에도",
      "이 옵션은 제공합니다",
      "더 나은 확장성을",
    ],
    englishChunks: [
      "Besides lower costs",
      "this option provides",
      "better scalability",
    ],
    fullEnglish:
      "Besides lower costs, this option provides better scalability.",
    additionalExplanation:
      "이 문장에서는 '~외에도(besides)'라는 전치사가 사용되었습니다. 전치사 'besides'는 '~외에도', '~이외에도', '~뿐만 아니라'라는 의미로 추가적인 정보나 요소를 소개할 때 사용됩니다. 해석할 때는 전치사 부분을 뒤에 붙여서 해석하지만, 영어로 말할 때는 전치사를 먼저 말하고 그 뒤에 명사구를 이어갑니다.",
  },
  {
    koreanChunks: ["협상이", "양측 사이에", "(현재)재개되었습니다"],
    englishChunks: ["The negotiations", "between both parties", "have resumed"],
    fullEnglish: "The negotiations between both parties have resumed.",
    additionalExplanation:
      "이 문장에서는 '~사이에(between)'라는 전치사가 사용되었습니다. 전치사 'between'은 '~사이에', '~간에'라는 의미로 두 개체 사이의 관계나 상호작용을 나타낼 때 사용됩니다. 이 문맥에서는 양측 간에 협상이 다시 시작되었다는 것을 표현합니다.",
  },
  {
    koreanChunks: ["이 문제는 위치해 있습니다", "범위를 넘어서 이 논의"],
    englishChunks: ["The issue lies", "beyond the scope of this discussion"],
    fullEnglish: "The issue lies beyond the scope of this discussion.",
    additionalExplanation:
      "이 문장에서는 '~을 넘어서(beyond)'라는 전치사가 사용되었습니다. 전치사 'beyond'는 '~을 넘어서', '~의 범위를 벗어나서', '~보다 더'라는 의미로 물리적 거리나 추상적인 한계를 넘어섬을 표현할 때 사용됩니다.",
  },
  {
    koreanChunks: ["최종 보고서는 제출되어야 합니다", "금요일까지"],
    englishChunks: ["The final report must be submitted", "by Friday"],
    fullEnglish: "The final report must be submitted by Friday.",
    additionalExplanation:
      "이 문장에서는 '~까지(by)'라는 전치사가 사용되었습니다. 전치사 'by'는 '~까지', '~에 의해', '~을 통해'라는 의미로 사용되며, 이 문맥에서는 시간적 기한을 나타냅니다.해석할 때는 전치사 부분을 뒤에 붙여서 해석하지만, 영어로 말할 때는 전치사를 먼저 말하고 그 뒤에 명사구를 이어갑니다.",
  },
  {
    koreanChunks: [
      "메모는 포함하고 있습니다",
      "새로운 지침들을",
      "원격 근무에 관한",
    ],
    englishChunks: [
      "The memo includes",
      "new guidelines",
      "concerning remote work",
    ],
    fullEnglish: "The memo includes new guidelines concerning remote work.",
    additionalExplanation:
      "이 문장에서는 '~에 관한(concerning)'이라는 전치사가 사용되었습니다. 전치사 'concerning'은 '~에 관한', '~에 대한', '~와 관련된'이라는 의미로 특정 주제나 사안과의 관련성을 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: ["지연에도 불구하고", "프로젝트는 완료되었습니다", "정시에"],
    englishChunks: [
      "Despite the delay",
      "the project was completed",
      "on time",
    ],
    fullEnglish: "Despite the delay, the project was completed on time.",
    additionalExplanation:
      "이 문장에서는 '~에도 불구하고(despite)'라는 전치사가 사용되었습니다. 전치사 'despite'는 '~에도 불구하고', '~에 상관없이'라는 의미로 예상과 다른 결과나 상황을 나타낼 때 사용됩니다. 계속해서 원어민이 이 말을 하려면 무슨 전치사를 떠올릴까? 하며 연습합니다. ",
  },
  {
    koreanChunks: ["파일들은 보관되어 있습니다", "복도를 따라", "오른쪽으로"],
    englishChunks: ["The files are stored", "down the hallway", "to the right"],
    fullEnglish: "The files are stored down the hallway to the right.",
    additionalExplanation:
      "이 문장에서는 방향을 나타내는 전치사 'down'과 'to'가 사용되었습니다. 'down'은 '~을 따라', '~을 내려가서'라는 의미로, 'to'는 '~으로', '~쪽으로'라는 의미로 방향이나 목적지를 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["어떤 전화 통화도 허용되지 않습니다", "훈련 세션 동안"],
    englishChunks: [
      "No phone calls are allowed",
      "during the training session",
    ],
    fullEnglish: "No phone calls are allowed during the training session.",
    additionalExplanation:
      "이 문장에서는 '~동안(during)'이라는 전치사가 사용되었습니다. 전치사 'during'은 '~동안', '~중에'라는 의미로 특정 기간이나 이벤트가 진행되는 시간을 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: [
      "모든 직원들은 참석해야 합니다 브리핑에",
      "인턴들을 제외하고",
    ],
    englishChunks: ["All staff must attend the briefing", "except interns"],
    fullEnglish: "All staff except interns must attend the briefing.",
    additionalExplanation:
      "이 문장에서는 '~을 제외하고(except)'라는 전치사가 사용되었습니다. 전치사 'except'는 '~을 제외하고', '~을 빼고'라는 의미로 특정 그룹이나 범주에서 일부를 제외할 때 사용됩니다. ",
  },
  {
    koreanChunks: ["가격은 $20입니다", "단위당", "세금을 제외하고"],
    englishChunks: ["The prices are $20", "per unit", "excluding tax"],
    fullEnglish: "The prices are $20 per unit, excluding tax.",
    additionalExplanation:
      "이 문장에서는 '~을 제외하고(excluding)'라는 전치사가 사용되었습니다. 전치사 'excluding'은 '~을 제외하고', '~을 포함하지 않고'라는 의미로 특정 항목이나 요소를 제외할 때 사용됩니다. 또한 'per'라는 전치사도 사용되었는데, 이는 '~당', '~마다'라는 의미로 비율이나 단위를 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["발표 이후", "직원 사기가 향상되었습니다"],
    englishChunks: ["Following the announcement", "employee morale improved"],
    fullEnglish: "Following the announcement, employee morale improved.",
    additionalExplanation:
      "이 문장에서는 '~이후(following)'라는 전치사가 사용되었습니다. 전치사 'following'은 '~이후에', '~에 뒤이어'라는 의미로 특정 사건이나 행동 이후의 시간적 순서를 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["이 직책은", "경험이 있는 엔지니어들만을 위한 것입니다"],
    englishChunks: ["This position is", "for experienced engineers only"],
    fullEnglish: "This position is for experienced engineers only.",
    additionalExplanation:
      "이 문장에서는 '~을 위한(for)'이라는 전치사가 사용되었습니다. 전치사 'for'는 '~을 위한', '~을 위하여'라는 의미로 목적이나 대상을 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: [
      "데이터는 (과거에)수집되었습니다",
      "1,000명 이상의 참가자들로부터",
    ],
    englishChunks: ["The data was collected", "from over 1,000 participants"],
    fullEnglish: "The data was collected from over 1,000 participants.",
    additionalExplanation:
      "이 문장에서는 '~로부터(from)'라는 전치사가 사용되었습니다. 전치사 'from'은 '~로부터', '~에서'라는 의미로 출처나 기원을 나타낼 때 사용됩니다. 또한 'over'라는 전치사도 사용되었는데, 이는 '~이상', '~을 넘는'이라는 의미로 수량이나 정도가 특정 기준을 초과함을 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["모든 기밀 문서들은 보관되어 있습니다", "캐비닛 안에"],
    englishChunks: [
      "All confidential documents are stored",
      "inside the cabinet",
    ],
    fullEnglish: "All confidential documents are stored inside the cabinet.",
    additionalExplanation:
      "이 문장에서는 '~안에(inside)'라는 전치사가 사용되었습니다. 전치사 'inside'는 '~안에', '~내부에'라는 의미로 어떤 공간이나 물체의 내부를 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["그녀는 (과거에)이동했습니다", "새 부서로", "지난 주에"],
    englishChunks: ["She moved", "into the new department", "last week"],
    fullEnglish: "She moved into the new department last week.",
    additionalExplanation:
      "이 문장에서는 '~로(into)'라는 전치사가 사용되었습니다. 전치사 'into'는 '~로', '~안으로'라는 의미로 어떤 공간이나 상태로 들어가는 움직임을 나타낼 때 사용됩니다. 이 문장에서는 그녀가 새로운 부서로 이동했다는 의미를 전달합니다.",
  },
  {
    koreanChunks: [
      "우리는 (현재) 필요합니다 후보자가",
      "한 씨와 같은",
      "이 직책을 위해",
    ],
    englishChunks: ["We need a candidate", "like Ms. Han", "for this position"],
    fullEnglish: "We need a candidate like Ms. Han for this position.",
    additionalExplanation:
      "이 문장에서는 '~와 같은(like)'이라는 전치사가 사용되었습니다. 전치사 'like'는 '~와 같은', '~와 비슷한'이라는 의미로 유사성이나 비교를 나타낼 때 사용됩니다. 또한 'for'라는 전치사도 사용되었는데, 이는 '~을 위한', '~을 위하여'라는 의미로 목적이나 대상을 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["사무실은", "기차역 근처에 있습니다."],
    englishChunks: ["The office is", "near the train station"],
    fullEnglish: "The office is near the train station.",
    additionalExplanation:
      "이 문장에서는 '~근처에(near)'라는 전치사가 사용되었습니다. 전치사 'near'는 '~근처에', '~가까이에'라는 의미로 물리적 위치가 가깝다는 것을 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: ["프린터는 위치해 있습니다", "복사기 옆에"],
    englishChunks: ["The printer is located", "next to the copier"],
    fullEnglish: "The printer is located next to the copier.",
    additionalExplanation:
      "이 문장에서는 '~옆에(next to)'라는 전치사구가 사용되었습니다. 전치사구 'next to'는 '~옆에', '~바로 옆에'라는 의미로 두 물체가 서로 인접해 있음을 나타낼 때 사용됩니다. 해석할 때는 전치사 부분을 뒤에 붙여서 해석하지만, 영어로 말할 때는 전치사를 먼저 말하고 그 뒤에 명사구를 이어갑니다.",
  },

  {
    koreanChunks: [
      "초기 우려에도 불구하고",
      "출시는 (과거에) 성공적이었습니다",
    ],
    englishChunks: [
      "Notwithstanding initial concerns",
      "the launch was a success",
    ],
    fullEnglish: "Notwithstanding initial concerns, the launch was a success.",
    additionalExplanation:
      "이 문장에서는 '~에도 불구하고(notwithstanding)'라는 전치사가 사용되었습니다. 전치사 'notwithstanding'는 '~에도 불구하고', '~에 상관없이'라는 의미로 어떤 상황이나 조건이 있음에도 불구하고 다른 일이 일어났음을 나타낼 때 사용됩니다. 비슷한 의미로 despite란 전치사가 있습니다.",
  },
  {
    koreanChunks: ["업로드하세요 파일들을", "공유 서버에", "정오 전에"],
    englishChunks: [
      "Upload the files",
      "onto the shared server",
      "before noon",
    ],
    fullEnglish: "Upload the files onto the shared server before noon.",
    additionalExplanation:
      "이 문장에서는 '~위에(onto)'라는 전치사가 사용되었습니다. 전치사 'onto'는 '~위에', '~로'라는 의미로 어떤 표면이나 장소로 이동하는 것을 나타낼 때 사용됩니다. 또한 'before'라는 전치사도 사용되었는데, 이는 '~전에'라는 의미로 시간적 선후관계를 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["인사과 사무실은", "재무부 맞은편에 있습니다"],
    englishChunks: ["The HR office is", "opposite the finance department"],
    fullEnglish: "The HR office is opposite the finance department.",
    additionalExplanation:
      "이 문장에서는 '~맞은편에(opposite)'라는 전치사가 사용되었습니다. 전치사 'opposite'는 '~맞은편에', '~반대편에'라는 의미로 두 물체나 장소가 서로 마주보고 있는 위치 관계를 나타낼 때 사용됩니다. 이 문장에서는 인사과 사무실이 재무부의 맞은편에 위치하고 있다는 공간적 관계를 표현합니다.",
  },
  {
    koreanChunks: ["방문객들은 반드시 기다려야 합니다", "회의 구역 밖에서"],
    englishChunks: ["Visitors must wait", "outside the meeting area"],
    fullEnglish: "Visitors must wait outside the meeting area.",
    additionalExplanation:
      "이 문장에서는 '~밖에(outside)'라는 전치사가 사용되었습니다. 전치사 'outside'는 '~밖에', '~외부에'라는 의미로 어떤 공간이나 영역의 바깥쪽을 나타낼 때 사용됩니다. 이 문장에서는 방문객들이 회의 구역의 외부에서 기다려야 한다는 위치 관계를 표현합니다.",
  },
  {
    koreanChunks: ["판매가 (과거에) 증가했습니다", "20%만큼", "지난 분기 동안"],
    englishChunks: ["Sales increased", "by 20%", "over the past quarter"],
    fullEnglish: "Sales increased by 20% over the past quarter.",
    additionalExplanation:
      "이 문장에서는 '~동안(over)'과 '~만큼(by)'이라는 전치사가 사용되었습니다. 전치사 'over'는 여기서 '~동안', '~에 걸쳐'라는 의미로 시간적 범위를 나타내며, 'by'는 '~만큼', '~에 의해'라는 의미로 변화의 정도나 수단을 나타낼 때 사용됩니다. 얼마나 한 문장에 전치사가 많이 쓰이는지 알 수 있습니다. 평상시에도 왜 이문장에서는 이 전치사를 썼을까? 고민하며 읽어보면 좋습니다. ",
  },
  {
    koreanChunks: ["출구는", "접수 데스크 지나서 있습니다"],
    englishChunks: ["The exit is", "just past the reception desk"],
    fullEnglish: "The exit is just past the reception desk.",
    additionalExplanation:
      "이 문장에서는 '~지나서(past)'라는 전치사가 사용되었습니다. 전치사 'past'는 '~을 지나서', '~을 넘어서'라는 의미로 어떤 지점이나 장소를 지나간 위치를 나타낼 때 사용됩니다. 'just'는 부사로 '바로', '막'이라는 의미를 더해 위치가 매우 가깝다는 것을 강조합니다. 이 문장에서는 출구가 접수 데스크를 지나 바로 그 너머에 있다는 위치 관계를 표현합니다.",
  },
  {
    koreanChunks: [
      "회사 정책에 따라",
      "모든 휴가는 승인되어야 합니다",
      "사전에",
    ],
    englishChunks: [
      "Per company policy",
      "all leave must be approved",
      "in advance",
    ],
    fullEnglish: "Per company policy, all leave must be approved in advance.",
    additionalExplanation:
      "이 문장에서는 '~에 따라(per)'와 '~에(in)'라는 전치사가 사용되었습니다. 전치사 'per'는 '~에 따라', '~당'이라는 의미로 규칙, 지침 또는 비율을 나타낼 때 사용됩니다. 이렇게 영어에서는 전치사로 말을 붙이기에 정말 많이 쓰입니다. 딱 정해진 뜻으로 외우기보다 뉘앙스로 이럴 때 쓰는구나 라는 느낌으로 앞으로 문장을 읽으면서 더 훈련하면 됩니다. ",
  },

  {
    koreanChunks: ["이 이메일은", "귀하의 요청에 관한 것입니다", "휴가를 위한"],
    englishChunks: ["This email is", "regarding your request", "for time off"],
    fullEnglish: "This email is regarding your request for time off.",
    additionalExplanation:
      "이 문장에서는 '~에 관한(regarding)'이라는 전치사가 사용되었습니다. 전치사 'regarding'은 '~에 관하여', '~에 대하여'라는 의미로 어떤 주제나 사안을 언급할 때 사용됩니다.",
  },
  {
    koreanChunks: ["그녀는 (현재) 일했습니다 여기서", "2019년부터"],
    englishChunks: ["She has worked here", "since 2019"],
    fullEnglish: "She has worked here since 2019.",
    additionalExplanation:
      "이 문장에서는 '~부터(since)'라는 전치사가 사용되었습니다. 전치사 'since'는 '~부터', '~이후로'라는 의미로 과거의 특정 시점부터 현재까지 계속되는 상황을 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: [
      "패키지는 (과거에) 발송되었습니다",
      "우리의 일반 택배를 통해",
    ],
    englishChunks: ["The package was sent", "through our regular courier"],
    fullEnglish: "The package was sent through our regular courier.",
    additionalExplanation:
      "이 문장에서는 '~를 통해(through)'라는 전치사가 사용되었습니다. 전치사 'through'는 '~를 통해', '~을 거쳐'라는 의미로 어떤 매개체나 수단을 나타낼 때 사용됩니다. 이 문장에서는 패키지가 발송된 방법이나 수단으로 일반 택배 서비스를 이용했다는 것을 표현합니다. 'through'는 경로, 수단, 방법 등을 나타내는 다양한 상황에서 활용됩니다.",
  },
  {
    koreanChunks: ["교육 세션이 진행될 예정입니다", "한 주 내내"],
    englishChunks: ["Training sessions will be held", "throughout the week"],
    fullEnglish: "Training sessions will be held throughout the week.",
    additionalExplanation:
      "이 문장에서는 '~내내(throughout)'라는 전치사가 사용되었습니다. 전치사 'throughout'는 '~동안 내내', '~전체에 걸쳐'라는 의미로 시간이나 공간의 전체 범위를 나타낼 때 사용됩니다. 이 문장에서는 교육 세션이 한 주의 전체 기간에 걸쳐 진행될 것임을 표현합니다. 'throughout'는 어떤 기간이나 장소의 전체에 걸쳐 무언가가 지속되거나 분포되어 있음을 강조할 때 사용되는 표현입니다.",
  },
  {
    koreanChunks: ["자금이 할당될 것입니다", "장비 업그레이드를 위해"],
    englishChunks: ["Funds will be allocated", "toward equipment upgrades"],
    fullEnglish: "Funds will be allocated toward equipment upgrades.",
    additionalExplanation:
      "이 문장에서는 '~을 향해(toward)'라는 전치사가 사용되었습니다. 전치사 'toward'는 '~을 향해', '~을 위해', '~을 향한 방향으로'라는 의미로 방향이나 목적을 나타낼 때 사용됩니다. 이 문장에서는 자금이 장비 업그레이드라는 특정 목적을 위해 할당된다는 것을 표현합니다. 'toward'는 물리적 방향뿐만 아니라 이처럼 목표나 목적을 향한 행동을 나타낼 때도 자주 사용됩니다.",
  },
  {
    koreanChunks: ["그녀의 태도가", "새로운 정책에 대해", "개선되었습니다"],
    englishChunks: ["Her attitude", "towards the new policy", "has improved"],
    fullEnglish: "Her attitude towards the new policy has improved.",
    additionalExplanation:
      "이 문장에서는 '~에 대해(towards)'라는 전치사가 사용되었습니다. 전치사 'towards'는 '~을 향해', '~에 대해', '~을 향한 방향으로'라는 의미로 방향이나 태도, 감정을 나타낼 때 사용됩니다. 이 문장에서는 그녀가 새로운 정책에 대해 가지는 태도나 감정이 개선되었다는 것을 표현합니다. 'towards'는 물리적 방향뿐만 아니라 이처럼 특정 대상에 대한 태도나 감정을 나타낼 때도 자주 사용됩니다.",
  },
  {
    koreanChunks: ["이 부서는 운영됩니다", "엄격한 지침 하에"],
    englishChunks: ["This department operates", "under strict guidelines"],
    fullEnglish: "This department operates under strict guidelines.",
    additionalExplanation:
      "이 문장에서는 '~하에(under)'라는 전치사가 사용되었습니다. 전치사 'under'는 '~아래에', '~하에', '~의 지배를 받아'라는 의미로 권위, 통제, 조건 등을 나타낼 때 사용됩니다. 이 문장에서는 부서가 엄격한 지침의 영향이나 통제 하에 운영된다는 것을 표현합니다. 'under'는 물리적으로 아래에 있는 위치뿐만 아니라 이처럼 규칙, 조건, 상황 등의 영향을 받는 상태를 나타낼 때도 자주 사용됩니다.",
  },
  {
    koreanChunks: ["가방을 보관해 주세요", "당신의 좌석 아래에"],
    englishChunks: ["Please store the bags", "underneath your seat"],
    fullEnglish: "Please store the bags underneath your seat.",
    additionalExplanation:
      "이 문장에서는 '~아래에(underneath)'라는 전치사가 사용되었습니다. 전치사 'underneath'는 '~의 아래에', '~의 밑에'라는 의미로 어떤 물체나 표면의 바로 아래 위치를 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["이 모델은 더 내구성이 있습니다", "이전 모델과 달리"],
    englishChunks: ["This model is more durable", "unlike the previous one"],
    fullEnglish: "This model is more durable unlike the previous one.",
    additionalExplanation:
      "이 문장에서는 '~와 달리(unlike)'라는 전치사가 사용되었습니다. 전치사 'unlike'는 '~와 달리', '~와는 다르게'라는 의미로 대조나 비교를 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: ["상점은 열려 있을 것입니다", "오후 9시까지"],
    englishChunks: ["The store will remain open", "until 9 p.m."],
    fullEnglish: "The store will remain open until 9 p.m.",
    additionalExplanation:
      "이 문장에서는 '~까지(until)'라는 전치사가 사용되었습니다. 전치사 'until'은 '~까지', '~하는 시점까지'라는 의미로 특정 시간이나 사건까지의 지속을 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: ["도착 시", "체크인 해주세요", "프론트 데스크에서"],
    englishChunks: ["Upon arrival", "please check in", "at the front desk"],
    fullEnglish: "Upon arrival, please check in at the front desk.",
    additionalExplanation:
      "이 문장에서는 '~시에(upon)'라는 전치사가 사용되었습니다. 전치사 'upon'은 '~할 때', '~하자마자', '~에'라는 의미로 특정 시간이나 사건이 발생하는 시점을 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: [
      "법원은 판결했습니다",
      "직원에게 유리하게",
      "회사에 대항하여",
    ],
    englishChunks: [
      "The court ruled",
      "in favor of the employee",
      "versus the company",
    ],
    fullEnglish: "The court ruled in favor of the employee versus the company.",
    additionalExplanation:
      "이 문장에서는 '~에 대항하여(versus)'라는 전치사가 사용되었습니다. 전치사 'versus'는 '~에 대항하여', '~에 반하여', '~와 대조적으로'라는 의미로 대립이나 경쟁 관계를 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: ["당신은 지원할 수 있습니다", "온라인 포털을 통해"],
    englishChunks: ["You can apply", "via the online portal"],
    fullEnglish: "You can apply via the online portal.",
    additionalExplanation:
      "이 문장에서는 '~을 통해(via)'라는 전치사가 사용되었습니다. 전치사 'via'는 '~을 통해', '~을 경유하여', '~을 거쳐'라는 의미로 경로, 수단, 방법을 나타낼 때 사용됩니다. ",
  },
  {
    koreanChunks: [
      "그녀는 (과거에)끝냈습니다 보고서를",
      "엄청난 집중과 함께",
      "디테일에",
    ],
    englishChunks: [
      "She completed the report",
      "with great attention",
      "to detail",
    ],
    fullEnglish: "She completed the report with great attention to detail.",
    additionalExplanation:
      "이 문장에서는 '~와 함께(with)'라는 전치사가 사용되었습니다. 전치사 'with'는 '~와 함께', '~을 가지고', '~을 사용하여'라는 의미로 동반, 수단, 방법, 태도 등을 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: ["응답해 주세요", "24시간 이내에"],
    englishChunks: ["Please respond", "within 24 hours"],
    fullEnglish: "Please respond within 24 hours.",
    additionalExplanation:
      "이 문장에서는 '~이내에(within)'라는 전치사가 사용되었습니다. 전치사 'within'은 '~이내에', '~안에', '~의 범위 내에'라는 의미로 시간, 공간, 범위의 한계를 나타낼 때 사용됩니다. 이 문장에서는 24시간이라는 시간적 한계 내에 응답해 달라는 요청을 표현합니다. 'within'은 특정 기간이나 범위 안에서 무언가가 발생해야 함을 명시할 때 자주 사용되는 표현입니다.",
  },
  {
    koreanChunks: ["제출하지 마세요 양식을", "서명 없이"],
    englishChunks: ["Do not submit the form", "without a signature"],
    fullEnglish: "Do not submit the form without a signature.",
    additionalExplanation:
      "이 문장에서는 '~없이(without)'라는 전치사가 사용되었습니다. 전치사 'without'은 '~없이', '~이 결여된', '~을 하지 않고'라는 의미로 부재나 결여를 나타낼 때 사용됩니다. 이 문장에서는 서명이 없는 상태로 양식을 제출하지 말라는 지시를 표현합니다. 'without'은 어떤 것이 없는 상태나 조건을 설명하거나, 어떤 행동이 특정 요소 없이 이루어지는 것을 나타낼 때 자주 사용되는 표현입니다.",
  },
  {
    koreanChunks: ["저는 항상 확인합니다 제 이메일을", "점심 전에"],
    englishChunks: ["I always check my email", "before lunch"],
    fullEnglish: "I always check my email before lunch.",
    additionalExplanation:
      "before는 전치사이기도 하고 접속사이기도 한 몇 안 되는 것 중 하나이니 암기합니다. after, before, since, until/till 이 4개는 전치사로도 접속사로도 쓰입니다.  ",
  },
  {
    koreanChunks: ["회의 후에", "우리는 팀 점심 식사를 했습니다"],
    englishChunks: ["After the meeting", "we had a team lunch"],
    fullEnglish: "After the meeting, we had a team lunch.",
    additionalExplanation:
      "이 문장에서는 '~후에(after)'라는 전치사가 사용되었습니다. 전치사 'after'는 '~후에', '~이후에'라는 의미로 시간적 순서를 나타낼 때 사용됩니다. 이 문장에서는 회의가 끝난 후에 팀 점심 식사를 했다는 시간적 순서를 표현합니다. 'after'는 before, since, until/till과 함께 전치사로도 접속사로도 쓰이는 단어 중 하나입니다.",
  },
  {
    koreanChunks: ["직원은 (현재) 휴가입니다", "월요일부터"],
    englishChunks: ["The employee has been on leave", "since Monday"],
    fullEnglish: "The employee has been on leave since Monday.",
    additionalExplanation:
      "이 문장에서는 '~부터(since)'라는 전치사가 사용되었습니다. 전치사 'since'는 '~부터', '~이후로'라는 의미로 과거의 특정 시점부터 현재까지 계속되는 상황을 나타낼 때 사용됩니다. 이 문장에서는 직원이 월요일부터 현재까지 계속 휴가 중임을 표현합니다. 'since'는 after, before, until/till과 함께 전치사로도 접속사로도 쓰이는 단어 중 하나입니다.",
  },
  {
    koreanChunks: ["사무실은 열려있습니다", "오후 9시까지"],
    englishChunks: ["The office remains open", "until 9 p.m."],
    fullEnglish: "The office remains open until 9 p.m.",
    additionalExplanation:
      "이 문장에서는 '~까지(until)'라는 전치사가 사용되었습니다. 전치사 'until'은 '~까지', '~할 때까지'라는 의미로 특정 시간이나 사건까지 지속되는 상황을 나타낼 때 사용됩니다. 이 문장에서는 사무실이 오후 9시까지 계속 열려있다는 것을 표현합니다. 'until'은 after, before, since와 함께 전치사로도 접속사로도 쓰이는 단어 중 하나입니다.",
  },
  {
    koreanChunks: ["행사가 지연되었습니다", "비 때문에"],
    englishChunks: ["The event was delayed", "because of the rain"],
    fullEnglish: "The event was delayed because of the rain.",
    additionalExplanation:
      "because만 쓰면 뒤에 절이 오는 접속사이지만 of와 함께 쓰이면 전치사입니다",
  },
  {
    koreanChunks: ["행사는 진행될 것입니다", "날씨에 상관없이"],
    englishChunks: ["The event will proceed", "regardless of the weather"],
    fullEnglish: "The event will proceed regardless of the weather.",
    additionalExplanation:
      "이 문장에서는 '~에 상관없이(regardless of)'라는 전치사구가 사용되었습니다. 'regardless of'는 '~에 상관없이', '~을 고려하지 않고'라는 의미로 어떤 조건이나 상황이 결과에 영향을 미치지 않음을 나타낼 때 사용됩니다. 이 문장에서는 날씨가 어떻든 상관없이 행사가 진행될 것임을 표현합니다. 'regardless of'는 어떤 장애물이나 어려움에도 불구하고 무언가가 계속될 것임을 강조할 때 자주 사용되는 표현입니다.",
  },
  {
    koreanChunks: [
      "시스템은 출시될 예정입니다",
      "불만에도 불구하고",
      "예정대로",
    ],
    englishChunks: [
      "The system will launch",
      "notwithstanding the complaints",
      "as scheduled",
    ],
    fullEnglish:
      "Notwithstanding the complaints, the system will launch as scheduled.",
    additionalExplanation:
      "이 문장에서는 '~에도 불구하고(notwithstanding)'라는 전치사가 사용되었습니다. 전치사 'notwithstanding'은 '~에도 불구하고', '~을 개의치 않고'라는 의미로 어떤 장애나 반대가 있음에도 불구하고 무언가가 진행됨을 나타낼 때 사용됩니다. 이 문장에서는 불만이 있음에도 불구하고 시스템이 예정대로 출시될 것임을 표현합니다. 'notwithstanding'은 다소 격식적인 표현으로, 'despite' 또는 'in spite of'와 유사한 의미를 가지고 있습니다.",
  },
];
